import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-[20px] pr-[0px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = { class: "lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]" }
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }

import visaNavigation from '@/components/SubNavigations/TheVisaNavigation.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'

    //breadcrumbs
    
export default /*@__PURE__*/_defineComponent({
  __name: 'VISAReceipts',
  setup(__props) {

    const breadcrumbs = [
        {
            title: 'VISA',
            disabled: false,
            href: 'visa',
        },
    ]

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(visaNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_breadcrumbs, { items: breadcrumbs }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]" }, [
        _createElementVNode("h1", null, "Hello World!")
      ], -1))
    ])
  ], 64))
}
}

})